var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('project-index',{attrs:{"tableColCheck":_vm.tableColCheck,"plat-name":"trans"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }